"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _store = _interopRequireDefault(require("@/store"));

var _router = _interopRequireDefault(require("@/router"));

var _vuex = require("vuex");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'Pagination',
  props: {
    pageIdent: {
      type: String,
      required: true
    },
    currentPage: {
      type: Number,
      required: true,
      default: 1
    },
    pageSize: {
      type: Number,
      required: true,
      default: 100
    },
    total: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      refresh: 0,
      localCurrentPage: this.currentPage,
      localPageSize: this.pageSize
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapState)('pagination', ['isAffaireRoute'])),
  watch: {
    localCurrentPage: function localCurrentPage(val) {
      localStorage.setItem("Pagination_".concat(this.pageIdent, "-currentPage"), val);
      this.$emit('"update:current-page', val); // Synchronisation avec le parent
    },
    localPageSize: function localPageSize(val) {
      localStorage.setItem("Pagination_".concat(this.pageIdent, "-pageSize"), val);
      this.$emit('update:page-size', val); // Synchronisation avec le parent
    }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.isAffaireRoute) {
                _context.next = 6;
                break;
              }

              _context.next = 3;
              return this.loadFromLocalStorage();

            case 3:
              this.refresh++;
              _context.next = 8;
              break;

            case 6:
              localStorage.removeItem("Pagination_".concat(this.pageIdent, "-currentPage"));
              localStorage.removeItem("Pagination_".concat(this.pageIdent, "-pagSize"));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    loadFromLocalStorage: function loadFromLocalStorage() {
      // Charger les valeurs de pagination depuis le localStorage
      var savedCurrentPage = parseInt(localStorage.getItem("Pagination_".concat(this.pageIdent, "-currentPage")), 10);
      var savedPageSize = parseInt(localStorage.getItem("Pagination_".concat(this.pageIdent, "-pageSize")), 10); // Initialiser les valeurs locales si elles existent dans le localStorage

      if (!isNaN(savedCurrentPage)) {
        this.localCurrentPage = savedCurrentPage;
      }

      if (!isNaN(savedPageSize)) {
        this.localPageSize = savedPageSize;
      }

      var maxpage = Math.ceil(this.total / this.localPageSize);

      if (this.localCurrentPage > maxpage) {
        this.localCurrentPage = 1;
      }

      this.$emit('update:page-size', this.localPageSize);
      this.$emit('update:current-page', this.localCurrentPage);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.localPageSize = val;
      this.$emit('update:page-size', val); // Synchroniser avec le parent
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.localCurrentPage = val;
      this.$emit('update:current-page', val); // Synchroniser avec le parent
    }
  }
};
exports.default = _default;

_router.default.beforeEach(function (to, from, next) {
  // Vérification si la route précédente contient "/affaire/{numéro}", "/commandes/{numéro}" ou "/factures/{numéro}"
  var affaireMatch = /\/(affaire|commandes|factures)\/\d+/.test(from.path);

  if (affaireMatch) {
    _store.default.dispatch('pagination/updateAffaireRoute', true);
  } else {
    _store.default.dispatch('pagination/updateAffaireRoute', false);
  }

  next();
});